import isLive from "../../../../../GesagtGetan.Basic/Resources/Private/Assets/Variables/isLive";
import Utils from "swiper/src/utils/utils";

import {
    $,
    addClass,
    removeClass,
    parent,
    closest,
    find,
    children,
    remove,
    add,
    insertAfter,
    appendTo
} from "dom7/dist/dom7.modular";

const Methods = {
    addClass,
    removeClass,
    parent,
    closest,
    find,
    children,
    remove,
    add,
    insertAfter,
    appendTo
};

Object.keys(Methods).forEach(methodName => {
    $.fn[methodName] = Methods[methodName];
});

Object.keys(Methods).forEach(methodName => {
    $.fn[methodName] = Methods[methodName];
});

function getDefaultSettings(nummberOfSlides = 2) {
    return {
        //preloadImages: false,
        //autoHeight: true,
        fadeEffect: {
            crossFade: true
        },

        simulateTouch: nummberOfSlides > 1 && isLive ? true : false,

        on: {
            init: function() {
                let slider = this.el;
                let params = this.originalParams;
                params.init = true;
                setTimeout(function() {
                    slider.data = params;
                    $(slider).addClass("swiper--initialized-true");
                    setTimeout(function() {
                        $(slider).removeClass("-no-transition-delay");
                    }, 1000);
                }, 10);
            },
            autoplayStart: function() {
                $(this.el).addClass("swiper--autoplay");
            },
            autoplayStop: function() {
                $(this.el).removeClass("swiper--autoplay");
            }
        }
    };
}

function createNavigationButtons() {
    let nav = ["prev", "next"];
    let buttons = {};
    for (let i = 0; i < nav.length; i++) {
        buttons[nav[i]] = $(
            '<div class="swiper-button swiper-button-' +
                nav[i] +
                '"><svg class="icon icon-' +
                nav[i] +
                '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-' +
                nav[i] +
                '"></use></svg></div>'
        )[0];
    }
    return buttons;
}

function writeNavigationButtons({ slider, insertAfter = false }) {
    $(slider)
        .parent()
        .find(".swiper-button-prev,.swiper-button-next")
        .remove();

    let buttons = createNavigationButtons();
    let $array = $(buttons.prev).add(buttons.next);
    if (insertAfter) {
        $array.insertAfter(slider);
    } else {
        $array.appendTo(slider);
    }

    return buttons;
}

function writeMarkup({
    cssClass = false,
    extraClass = false,
    slider,
    insertAfter
}) {
    if (cssClass) {
        extraClass = extraClass ? " " + extraClass : "";
        $(slider)
            .parent()
            .find(`.${cssClass}`)
            .remove();
        let $element = $(`<div class="${cssClass}${extraClass}"></div>`);
        if (insertAfter) {
            $element.insertAfter(slider);
        } else {
            $element.appendTo(slider);
        }

        return $element[0];
    }
    return false;
}

function writePagination({ slider, insertAfter = false, extraClass = false }) {
    let cssClass = "swiper-pagination";
    let pagination = writeMarkup({
        cssClass,
        extraClass,
        slider,
        insertAfter
    });
    return pagination;
}

function randomizeOrderFromChildren(element) {
    for (let i = element.children.length; i >= 0; i--) {
        element.appendChild(element.children[(Math.random() * i) | 0]);
    }
}

function mergeSettings({ settings = {}, typeSettings = {}, nummberOfSlides }) {
    // Get default settings
    let options = getDefaultSettings(nummberOfSlides);
    // Overwrite options from typeSettings and settings
    return Utils.extend(options, typeSettings, settings);
}

export {
    getDefaultSettings,
    createNavigationButtons,
    writeNavigationButtons,
    writeMarkup,
    writePagination,
    mergeSettings
};
